var webSocket = new WebSocket('wss://127.0.0.1:13579/')
var missedHeartbeatsLimit = 3
var missedHeartbeatsLimitMax = 50
var heartbeatInterval = null
var heartbeatMsg = '--heartbeat--'
var missedHeartbeats = 0
var callback = []
var dev = process.env.NODE_ENV !== 'production'

webSocket.onopen = function (event) {
    if (heartbeatInterval === null) {
        missedHeartbeats = 0
        heartbeatInterval = setInterval(pingLayer, 2000)
    }
}

webSocket.onclose = function (event) {
    if (event.wasClean && dev) {
        console.log('connection has been closed')
    } else {
        if (dev) {
            console.log('Connection error')
        }
        openDialog()
    }
    if (dev) {
        console.log('Code: ' + event.code + ' Reason: ' + event.reason)
    }
}

webSocket.onmessage = function (event) {
    if (event.data === heartbeatMsg) {
        missedHeartbeats = 0
        return
    }

    var result = JSON.parse(event.data)

    if (result != null) {
        var rw = {
            code: result['code'],
            message: result['message'],
            responseObject: result['responseObject'],
            getResult: function () {
                return this.result
            },
            getMessage: function () {
                return this.message
            },
            getResponseObject: function () {
                return this.responseObject
            },
            getCode: function () {
                return this.code
            }
        }
        if (rw.responseObject != null && callback[rw.responseObject.callID] != null && callback[rw.responseObject.callID] != null) {
            callback[rw.responseObject.callID](rw)
        }
    }
    setMissedHeartbeatsLimitToMin()
}

var setMissedHeartbeatsLimitToMax = function () {
    missedHeartbeatsLimit = missedHeartbeatsLimitMax
}
var setMissedHeartbeatsLimitToMin = function () {
    missedHeartbeatsLimit = 3
}

function openDialog () {
    if (confirm('Ошибка при подключении к прослойке. Убедитесь что программа запущена и нажмите ОК') === true) {
        location.reload()
    }
}

function pingLayer () {
    try {
        missedHeartbeats++
        if (missedHeartbeats >= missedHeartbeatsLimit) {
            throw new Error('Too many missed heartbeats.')
        }
        webSocket.send(heartbeatMsg)
    } catch (e) {
        clearInterval(heartbeatInterval)
        heartbeatInterval = null
        if (dev) {
            console.warn('Closing connection. Reason: ' + e.message)
        }
        webSocket.close()
    }
}

function createCallId (size) {
    var callId = ''
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    for (var i = 0; i < size; i++) {
        callId += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    return callId
}

export default {
    install: Vue => {
        Vue.prototype.$ncalayer = {
            signXml (xmlToSign, callBack) {
                var callId = createCallId(12)
                var sendData = {
                    'module': 'kz.qiwi.osgi.SecurityUtils',
                    'method': 'signXml',
                    'args': [callId, xmlToSign, '', '']
                }
                callback[callId] = callBack
                setMissedHeartbeatsLimitToMax()
                webSocket.send(JSON.stringify(sendData))
            },
            breakSession (callBack) {
                var callId = createCallId(12)
                var sendData = {
                    'module': 'kz.qiwi.osgi.SecurityUtils',
                    'method': 'logOut',
                    'args': [callId]
                }
                callback[callId] = callBack
                setMissedHeartbeatsLimitToMax()
                webSocket.send(JSON.stringify(sendData))
            }
        }
    }
}
